import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ONETRUSTLICENSE } from '../constants/cookiebanner-constants';

@Injectable({
  providedIn: 'root'
})
export class OneTrustCookieBannerService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  loadScripts() {
    const oneTrustScript = this.document.createElement('script');
    oneTrustScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    oneTrustScript.type = 'text/javascript';
    oneTrustScript.setAttribute('data-domain-script', ONETRUSTLICENSE);
    this.document.body.appendChild(oneTrustScript);

    const optAnonWrapperScript = this.document.createElement('script');
    optAnonWrapperScript.type = 'text/javascript';
    const optAnonFunc = this.document.createTextNode('function OptanonWrapper(){}');
    optAnonWrapperScript.appendChild(optAnonFunc);
    this.document.body.appendChild(optAnonWrapperScript);
  }
}
